module.exports = __webpack_public_path__ + "static/logo-icon-white-bg-d3ede50588107fbc88bf0bdd0fd7b084.png";